import ExcelJS from 'exceljs';

/** Paleta de semáforo reaproveitada nos relatórios (uso, empresas). */
export const CORES_SEMAFORO = {
  Alto: { fundo: 'FFC6EFCE', texto: 'FF006100' },
  Médio: { fundo: 'FFFFEB9C', texto: 'FF9C6500' },
  Baixo: { fundo: 'FFFFC7CE', texto: 'FF9C0006' },
} as const;

export function estilizarCabecalho(sheet: ExcelJS.Worksheet) {
  const header = sheet.getRow(1);
  header.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF1F2937' } };
    cell.alignment = { vertical: 'middle', horizontal: 'center', wrapText: true };
  });
  header.height = 22;
  sheet.views = [{ state: 'frozen', ySplit: 1 }];
}

export function autoWidth(sheet: ExcelJS.Worksheet, mins: Record<string, number> = {}) {
  sheet.columns.forEach((col) => {
    let max = mins[col.key as string] || 8;
    col.eachCell?.({ includeEmpty: true }, (cell) => {
      const len = cell.value ? String(cell.value).length : 0;
      if (len > max) max = len;
    });
    col.width = Math.min(max + 2, 42);
  });
}

export function zebra(sheet: ExcelJS.Worksheet) {
  for (let r = 2; r <= sheet.rowCount; r++) {
    if ((r - 2) % 2 === 1) {
      sheet.getRow(r).eachCell({ includeEmpty: true }, (cell) => {
        if (!cell.fill) {
          cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFF3F4F6' } };
        }
      });
    }
  }
}
